import { Observable } from 'rxjs';

export abstract class InsightsRepository {
    abstract getInsights(uid: string, cid: string | null, insight: string, period: string): Observable<any>;
}
